import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CalendarField from '../../../components/Fields/CalendarField';
import { dateFilterStyle } from './dateFilterStyle';

const useStyles = makeStyles(() => dateFilterStyle);

function useFrontbaseDateFilter(props) {
  const {
    id,
    name,
    label,
    onChange: passedInOnChange,
    selectedDay,
    disabledDays,
    setFieldValue,
    ...restOfThePropsAndHandlers
  } = props;

  const onChange = day => {
    // eslint-disable-next-line no-unused-expressions
    passedInOnChange && passedInOnChange(day);
  };

  return {
    id,
    name,
    label,
    onChange,
    selectedDay,
    disabledDays,
    ...restOfThePropsAndHandlers,
  };
}

export const DateFilter = React.memo(function DateFilter(props) {
  const enhancedProps = useFrontbaseDateFilter(props);
  const classes = useStyles();
  const overrideProps = {
    overrides: {
      classes,
    },
  };
  return <CalendarField {...enhancedProps} {...overrideProps} />;
});
